// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll('.itg_fade_up, .itg_fade_down , .itg_fade-in-out , .itg_fade_left, .itg_fade_right').forEach(el => {
//     const delay = el.dataset.animation_delay || 0;
//     setTimeout(() => {
//       el.classList.add('animated');
//     }, parseFloat(delay) * 1000);
//   }); 
// });



// document.addEventListener("DOMContentLoaded", () => {
//   const els = document.querySelectorAll('.itg_fade_up, .itg_fade_down, .itg_fade-in-out, .itg_fade_left, .itg_fade_right');

//   const onScrollAnimate = (el, delay) => {
//     const observer = new IntersectionObserver((entries, obs) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           setTimeout(() => el.classList.add('animated'), delay);
//           obs.unobserve(el);
//         }
//       });
//     }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
//     observer.observe(el);
//   };

//   els.forEach(el => {
//     const delay = parseFloat(el.dataset.animation_delay || 0) * 1000;
//     const trigger = (el.dataset.animation_trigger || 'scroll').toLowerCase();

//     if (trigger === 'load') {
//       setTimeout(() => el.classList.add('animated'), delay);
//     } else {
//       onScrollAnimate(el, delay);
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll('.shopify-section');

  sections.forEach(section => {
    const els = section.querySelectorAll('.itg_fade_up, .itg_fade_down, .itg_fade-in-out, .itg_fade_left, .itg_fade_right');
    if (els.length === 0) return;
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          els.forEach(el => {
            const delay = parseFloat(el.dataset.animation_delay || 0) * 1000;
            const trigger = (el.dataset.trigger || 'scroll').toLowerCase();
            if (trigger === 'load') {
              setTimeout(() => el.classList.add('animated'), delay);
            } else {
              setTimeout(() => el.classList.add('animated'), delay);
            }
          });
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -10% 0px',
    });
    observer.observe(section);
  });
});
